import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

const ViewPointMapPlan = (props) => {
  const { viewpoint, currentPano, selectSceneById } = props;
  const json = useSelector((state) => state.json);
  const sceneList = json.scenes;

  const [isHovered, setIsHovered] = useState(false);

  const currentPoint = viewpoint.id === currentPano._id;
  const currentScene = sceneList.find((s) => s._id === viewpoint.id) || {};

  const pos = useMemo(() => {
    const [left, top] = viewpoint.coordinates;

    return {
      left: left * 100,
      top: top * 100,
    };
  }, [viewpoint.coordinates]);

  const hardcodeCssCurrentPoint = useMemo(
    () => currentPano._id === '675166bb97d14bbd943b566d',
    [currentPano._id]
  );

  return (
    <>
      <div
        className="viewpoint-title-container"
        style={{
          left: `${pos.left}%`,
          top: `${pos.top}%`,
          opacity: isHovered ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <div className="viewpoint-title">{currentScene.title}</div>
      </div>
      <div
        className={`viewpoint-container ${
          currentPoint ? 'current-viewpoint' : `viewpoint`
        } ${hardcodeCssCurrentPoint ? 'doubleSize' : ''} ${
          currentPoint && hardcodeCssCurrentPoint ? 'deviatedFixing' : ''
        }`}
        style={{
          left: `${pos.left}%`,
          top: `${pos.top}%`,
        }}
        onClick={() =>
          !currentPoint &&
          selectSceneById(currentScene.groupId, currentScene.id)
        }
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      ></div>
    </>
  );
};

export default ViewPointMapPlan;
